
<script>
export default {

    data() {
        return {
            file: {
                name: '',
                formData: ''
            },
            allowedTypes: [
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                "application/vnd.ms-excel"
            ],
        };
    },
    methods: {
        showFileChooser() {
            setTimeout(() => {
                this.$refs.uploadInput.click();
            }, 50)
        },
        fileChoose(event){
            if (event.target.files.length) {
                this.filePrepare(event.target.files[0])
            }
        },
        clearFileData(){
            this.$refs.uploadInput.value = '';
            this.file = {
                name: '',
                formData: ''
            }
        },
        filePrepare(file) {
            if(this.allowedTypes.indexOf(file.type) === -1 ){
                this.$root.showErrorDialog({
                    message: 'Некорректный тип файла!'
                });
                return;
            }
            let reader = new FileReader();
            this.file.name = file.name
            let formData = new FormData();
            formData.append('pricelist', file)
            this.file.formData = formData;

            reader.onerror = function (error) {
                console.log('Error: ', error);
            };
        },
    },
    watch: {
        'file.name': function (newVal) {
            if(newVal === ''){
                this.file.formData = '';
            }
        },
    }
}
</script>

<style>

</style>
